import React, { Component } from "react";
import Helmet from "../component/common/HelmetApple";
import ScrollspyTeste from 'react-scrollspy';
import ScrollSpy from "react-ui-scrollspy";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp, FiX, FiMenu } from "react-icons/fi";
import FooterOne from "../component/footer/Footer";
import AppleBM from "../blocks/about/AppleBM";
import AboutApple from "../component/HomeLayout/homeOne/AboutApple";
import HubspotContactForm from '../elements/Hubspot';
import { HubspotProvider } from '@aaronhayes/react-use-hubspot-form';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import AppleFinancial from "../blocks/about/AppleFinancial";


// const iconLogo = <img src="assets/images/bg/pYellow.svg" alt="Plugify Gali" />

const SlideList = [
    {
        textPosition: 'text-left',
        category: 'Mais eficiência e praticidade na gestão do seu parque com locação de equipamentos Apple',
        description: '',
        buttonText: ''
    }
]

class ApplePage extends Component {
    constructor(props) {
        super(props);
        this.menuTrigger = this.menuTrigger.bind(this);
        this.CLoseMenuTrigger = this.CLoseMenuTrigger.bind(this);
        this.stickyHeader = this.stickyHeader.bind(this);

        window.addEventListener('load', function () {
            // console.log('All assets are loaded');
        })
    }
    menuTrigger() {
        document.querySelector('.header-wrapper').classList.toggle('menu-open')
    }
    CLoseMenuTrigger() {
        document.querySelector('.header-wrapper').classList.remove('menu-open')
    }
    stickyHeader() { }
    render() {
        window.addEventListener('scroll', function () {
            var value = window.scrollY;
            if (value > 100) {
                document.querySelector('.header--fixed').classList.add('sticky')
            } else {
                document.querySelector('.header--fixed').classList.remove('sticky')
            }
        });
        return (
            // <Fragment>
            <div className="active-dark">
                <Helmet pageTitle="Plugify">
                
                    
                </Helmet> 
                {/* Start Header Area  */}
                <header className="header-area formobile-menu header--fixed default-color">
                    <div className="header-wrapper" id="header-wrapper">
                        <div className="header-left">
                            <div className="logo">
                                <Link to="../">
                                    <div data-to-scrollspy-id="home" className={"ss-item"}></div>
                                    <img className="logo-1" src="/assets/images/logo/logo-light.png" alt="Plugify" />
                                    <img className="logo-2" src="/assets/images/logo/logo-all-dark.png" alt="Plugify" />
                                </Link>

                            </div>
                        </div>
                        <div className="header-right">
                            <nav className="mainmenunav d-lg-block">

                                <ScrollspyTeste className="mainmenu" items={['home', 'sobre', 'solucoes', 'gali', 'time', ' ', 'contato']} currentClassName="is-current" offset={-200}>
                                    <li><HashLink smooth to="../">Home</HashLink></li>
                                    <li>
                                        <HashLink scroll={(el) => el.scrollIntoView({ behavior: 'smooth' })}
                                            to={'../#sobre'}>A Plugify</HashLink>
                                    </li>
                                    <li>
                                        <HashLink scroll={(el) => el.scrollIntoView({ behavior: 'smooth' })}
                                            to={'../#solucoes'}>Soluções</HashLink>
                                    </li>
                                    <li>
                                        <HashLink scroll={(el) => el.scrollIntoView({ behavior: 'smooth' })}
                                            to={'../#gali'}>Plataforma de gestão</HashLink>
                                    </li>
                                    <li>
                                        <HashLink scroll={(el) => el.scrollIntoView({ behavior: 'smooth' })}
                                            to={'../#time'}>Time Plugify</HashLink>
                                    </li>
                                    <li className="line-apple-active">
                                        <p className="apple-active">Apple Reseller</p>
                                    </li>
                                    <li>
                                        <HashLink scroll={(el) => el.scrollIntoView({ behavior: 'smooth' })}
                                            to={'#contato'}>Contato</HashLink>
                                    </li>
                                </ScrollspyTeste>
                            </nav>

                            <div className="header-btn">
                                <img className="logo-1" src="/assets/images/featured/appleReseller.png" alt="Apple Corporate Reseller" width={130} />
                            </div>
                            {/* Start Humberger Menu  */}
                            <div className="humberger-menu d-block d-lg-none pl--20">
                                <span onClick={this.menuTrigger} className="menutrigger text-white"><FiMenu /></span>
                            </div>
                            {/* End Humberger Menu  */}
                            <div className="close-menu d-block d-lg-none">
                                <span onClick={this.CLoseMenuTrigger} className="closeTrigger"><FiX /></span>
                            </div>
                        </div>
                    </div>
                </header>
                {/* End Header Area  */}
                <ScrollSpy scrollThrottle={100} useBoxMethod={false} >
                    {/* Start Slider Area   */}
                    <div className="slide-abre" id=" " >
                        {/* Start Single Slide */}
                        {SlideList.map((value, index) => (
                            <div className="slider-style-3 d-flex align-items-center justify-content-center bg_image--25_Apple" key={index}>
                                <div className="container">
                                    <div className="row">
                                        <div className="col-lg-8">
                                            <div className={`inner ${value.textPosition}`}>
                                                <p className="innerApple">{value.category}</p>
                                                {/* <h2>#aluguecomagente</h2> */}
                                                {value.description ? <p className="description">{value.description}</p> : ''}
                                                <a className="btn-default btn-border btn-opacity"
                                                    onClick href="#contato">
                                                    <div data-to-scrollspy-id="apple" className={"ss-item"}>
                                                    #aluguecomagente
                                                    </div>
                                                </a>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        ))}
                        {/* End Single Slide */}
                    </div>
                    {/* End Slider Area   */}

                    {/* Start Portfolio Area */}
                    <div className="portfolio-area bg_color--1 bg_image bg_image--apple" id="apple">
                        <div className="rn-slick-dot">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-5 boxTextApple">
                                        <div className="section-title text-left mb--15 mb_sm--0">
                                            <div className='bgTitleApple '>
                                                <span className="subtitle subtitleApple">Apple Corporate Reseller</span>
                                            </div>
                                            <h2 className="titleProdApple" >Por que<br />Plugify empresas</h2>
                                            <span className="descriptionApple2">A <strong>Plugify</strong> é um <strong>Apple Authorized Corporate Reseller</strong> e tem acesso às melhores ofertas e às mais recentes inovações que a Apple traz para o mundo corporativo, desde o super-poderoso chip M1, aos melhores métodos de ﬁnanciamento, via Apple Financial Services.</span>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                    {/* End Portfolio Area */}

                    {/* Start About Area */}
                    <div className="about-areaSolucoesApple" id=" ">
                        <AboutApple />
                    </div>
                    {/* End About Area */}


                    {/* Start About Area */}
                    <div className="slide-abre" id=" ">
                        <AppleBM />
                    </div>
                    {/* End About Area */}

                    {/* Start About Area */}
                    <div className="about-areaFinancial bg_image--financial" id=" ">
                        <AppleFinancial />
                    </div>
                    {/* End About Area */}

                    {/* Start Contact Us */}
                    <div className="ptb--120 bg_color--form col-lg-12 bg_contato_plugify" id="contato">
                        <div className="container">
                            <div className="row container--form">
                                <div className="col-lg-7 bg_Form">
                                    <div className="section-title text-left mb--25 mb_sm--0">
                                        {/* <div className='bgTitleApple'>
                                            <span className="subtitle">fale com a gente</span>
                                        </div> */}
                                        <h2 className="titleProdApple" style={{ color: '#000' }}> Preencha o formulário para entrarmos em contato.</h2>
                                    </div>
                                    <HubspotProvider>
                                        <HubspotContactForm />
                                    </HubspotProvider>
                                </div>
                            </div>
                            {/* <Contact /> */}
                        </div>
                    </div>
                    {/* End Contact Us */}
                </ScrollSpy>

                {/* Start Footer Style  */}
                <FooterOne />
                {/* End Footer Style  */}

               {/* Start Back To Top */}
               <div className="backto-top">
                    <ScrollToTop 
                        showUnder={160}
                        easing='easeInQuad'
                        duration={700}
                    >
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}

            </div>
            // </Fragment>

        )
    }
}

export default ApplePage;